import { SupportNodeCalcStatusToolTypes } from '@symon-ai/wisepipe-base-pipe';
export var NodeCalculationStatus;
(function (NodeCalculationStatus) {
    NodeCalculationStatus["Successful"] = "successful";
    NodeCalculationStatus["Failed"] = "failed";
    NodeCalculationStatus["Skipped"] = "skipped";
    NodeCalculationStatus["Unprocessed"] = "unprocessed";
})(NodeCalculationStatus || (NodeCalculationStatus = {}));
export function nodeSupportsCalcStatus(node) {
    return SupportNodeCalcStatusToolTypes.includes(node.toolType);
}
export function filterNodesSupportingCalcStatus(nodes) {
    return nodes.filter(nodeSupportsCalcStatus);
}
//# sourceMappingURL=nodeCalculationStatus.js.map